import { store } from '../store'
import waitForAuthReady from './wait-for-auth'

export default async (to, from, next) => {
  // Wait for Firebase to restore the persisted session before deciding, so a
  // hard refresh on a protected route doesn't redirect an authenticated user.
  await waitForAuthReady()

  if (store.getters.user) {
    next()
  } else {
    // Preserve the intended destination (e.g. a notification deep link into
    // /alarms) so the user is returned there once authentication is restored,
    // instead of always landing on the default page.
    next({ path: '/signin', query: { redirect: to.fullPath } })
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js